import { ThemeMode } from '@fluent-theme-tools/color-operations';
import type { Theme } from '@fluentui/react-components';
import { createDarkTheme, createLightTheme } from '@fluentui/react-components';
import { createBrandVariants } from '@fluentui/react-migration-v8-v9';

import type { ITheme } from '../../styling';

import { createCoreUIFluentTheme } from './createCoreUIFluentTheme';
import { createCustomFluent9Theme } from './createCustomFluent9Theme';

export { createCoreUIFluentTheme };

/**
 * Takes a Fluent 8 theme and returns a new Fluent 9 theme with typography values converted to rems
 * and brand colors from the given Fluent 8 theme.
 */
export const createCoreUIFluentThemeFromV8 = (theme: ITheme): Theme => {
  // user/tenant tenant themes get a new theme based on the primary colour only. This ensures valid constrast ratios
  if (theme.name?.endsWith(':User') || theme.name?.endsWith(':Tenant')) {
    return createCustomFluent9Theme(theme.palette.themePrimary, theme.isInverted ? ThemeMode.Dark : ThemeMode.Light);
  }

  const brandVariants = createBrandVariants(theme.palette);
  const baseTheme = theme.isInverted ? createDarkTheme(brandVariants) : createLightTheme(brandVariants);

  return createCoreUIFluentTheme(baseTheme);
};
